import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, signal } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ProprieteAffichee } from 'src/app/bo/proprieteAffichee';
import { FonctionsService } from 'src/app/services/fonctions-partagees.service';
import { HttpService } from 'src/app/services/http.service';
import { UtilisateurService } from 'src/app/services/utilisateur.service';
import { RockTypeModalComponent } from '../rock-type-modal/rock-type-modal.component';
import { RockType } from 'src/app/bo/geology/rockType';

@Component({
  selector: 'app-rock-type-gui',
  templateUrl: './rock-type-gui.component.html',
  styleUrls: ['./rock-type-gui.component.scss'],
  standalone: false
})
export class RockTypeGuiComponent implements OnInit {

  currentSiteId: number = undefined;
  rockTypeModal: BsModalRef;
  table_width: number[] = [3, 12, 13, 13, 14, 13, 13, 9, 10];
  showErrorModif = false;
  showErrorNew = false;
  tabRockTypes = signal<RockType[]>([]);
  selectedRockType: RockType = undefined;
  readonly proprietesAffichees = signal<ProprieteAffichee[]>([]);
  isModifiable = -1;
  lastToucheIndex = -1;
  isFooterFocus: boolean;
  readonly activeSort = signal<number>(undefined);
  readonly arrowSort = signal<boolean[]>([]);

  constructor(
    private readonly http: HttpService,
    public utilService: UtilisateurService,
    private readonly fonctionsService: FonctionsService,
    private readonly modalService: BsModalService
  ) {
    const props = new RockType().getProprietesAffichees();
    this.proprietesAffichees.set(props);
    this.arrowSort.set(props.map(() => false));
  }

  ngOnInit(): void {
    this.currentSiteId = this.utilService.currentSite()?.siteId;
    this.getRockTypesBySiteId();
    this.modalService.onHide.subscribe((reload: string) => {
      if (reload === 'true') {
        this.getRockTypesBySiteId();
      }
      this.clearSelected();
    });
  }

  protected selectRockType(event:any, rockType: RockType){
    event.stopPropagation()


    const initialState = {
      siteId: this.utilService.currentSite().siteId,
      selectedRockType: Object.assign({}, rockType),
      isModif: true
    };

    this.rockTypeModal = this.modalService.show(RockTypeModalComponent, {
      class: 'modal-lg',
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: false,
      initialState,
    });

  }

  protected ouvrirModaleAdd() {

    const initialState = {
      siteId: this.utilService.currentSite().siteId,
      selectedRockType: new RockType(),
      isModif: false
    };

    this.rockTypeModal = this.modalService.show(RockTypeModalComponent, {
      class: 'modal-lg',
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: false,
      initialState,
    });
  }

  protected clearSelected() {
    this.selectedRockType = new RockType();
  }

  private getRockTypesBySiteId() {
    this.fonctionsService.loading_screen(true);
    this.tabRockTypes.set([]);

    const url = "Geology/rocktype/" + this.utilService.currentSite().siteId;

    this.http.get<RockType[]>(url).subscribe({
      next: result => {
        this.tabRockTypes.set(result);
        this.fonctionsService.loading_screen(false);
      },
      error: (error: HttpErrorResponse) => {
        if (error.status === 401 || error.status === 403) {
          console.log(error.error);
        }
        this.fonctionsService.launch_toast(false);
        this.fonctionsService.loading_screen(false);
      }
    })
  }

  protected sortBy(propriete: ProprieteAffichee, i: number) {
    const arr = [...this.arrowSort()];
    arr[i] = !arr[i];
    this.arrowSort.set(arr);
    this.activeSort.set(i);
    this.isModifiable = -1;
    if (arr[i]) {
      this.tabRockTypes.set([...this.tabRockTypes()].sort((a, b) =>
        a[propriete.nom] < b[propriete.nom] ? -1 : a[propriete.nom] > b[propriete.nom] ? 1 : 0
      ));
    } else {
      this.tabRockTypes.set([...this.tabRockTypes()].sort((a, b) =>
        b[propriete.nom] < a[propriete.nom] ? -1 : b[propriete.nom] > a[propriete.nom] ? 1 : 0
      ));
    }
  }


}
